var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAccountLocations)?_c('div',[_c('i',{staticClass:"far fa-map-marker-alt mr-2"}),_vm._v(" "+_vm._s(_vm.filteredLocationListDisplay)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }